import { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import "./UpdateInventoryManually.css"; // Reuse same styles

const UpdateInventoryManually = () => {
  const [formData, setFormData] = useState({
    drug_name: "",
    quantity: "",
    price: "",
    expiration_date: "",
    nafdac_number: "",
  });

  const [drugList, setDrugList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const token = localStorage.getItem("access_token");

  // Fetch available drugs for dropdown
  useEffect(() => {
    const fetchDrugs = async () => {
      try {
        const response = await fetch("http://127.0.0.1:8000/pharmacies/drugs/", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) throw new Error("Failed to fetch drugs");
        const data = await response.json();
        setDrugList(data);
      } catch (err) {
        console.error(err);
        setError("Unable to load drug list.");
      }
    };
    fetchDrugs();
  }, [token]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.drug_name) return setError("Please select a drug.");
    if (!formData.quantity) return setError("Please enter the quantity.");
    if (isNaN(formData.quantity) || parseInt(formData.quantity) <= 0)
      return setError("Quantity must be a positive number.");
    if (!formData.price) return setError("Please enter the price.");
    if (isNaN(formData.price) || parseFloat(formData.price) <= 0)
      return setError("Price must be a valid number.");
    if (!formData.expiration_date)
      return setError("Please select an expiration date.");
    if (!formData.nafdac_number)
      return setError("Please enter the NAFDAC number.");

    setError("");
    setSuccess("");

    try {
      const response = await fetch(
        "http://127.0.0.1:8000/pharmacies/update_inventory",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            drug_name: formData.drug_name,
            quantity: parseInt(formData.quantity),
            price: parseFloat(formData.price),
            nafdac_number: formData.nafdac_number,
            expiration_date: formData.expiration_date,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to update drug.");
      }

      setSuccess("✅ Drug updated successfully!");
      setFormData({
        drug_name: "",
        quantity: "",
        price: "",
        expiration_date: "",
        nafdac_number: "",
      });
    } catch (err) {
      setError(`❌ ${err.message}`);
    }
  };

  const filteredDrugs = drugList.filter((drug) =>
    drug.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="layout">
      <Sidebar />
      <div className="main-content">
        <h1 className="title">✏️ Update Inventory Manually</h1>

        {error && <p className="error-msg">{error}</p>}
        {success && <p className="success-msg">{success}</p>}

        <form onSubmit={handleSubmit} className="inventory-form">
          <label>
            Drug Name:
            <select
              name="drug_name"
              value={formData.drug_name}
              onChange={handleChange}
            >
              <option value="">-- Select Drug --</option>
              {filteredDrugs.map((drug) => (
                <option key={drug.id} value={drug.name}>
                  {drug.name}
                </option>
              ))}
            </select>
          </label>

          <label>
            Quantity:
            <input
              type="number"
              name="quantity"
              value={formData.quantity}
              onChange={handleChange}
              placeholder="Enter new quantity"
            />
          </label>

          <label>
            Price:
            <input
              type="number"
              step="0.01"
              name="price"
              value={formData.price}
              onChange={handleChange}
              placeholder="Enter new price"
            />
          </label>

          <label>
            Expiration Date:
            <input
              type="date"
              name="expiration_date"
              value={formData.expiration_date}
              onChange={handleChange}
            />
          </label>

          <label>
            NAFDAC Number:
            <input
              type="text"
              name="nafdac_number"
              value={formData.nafdac_number}
              onChange={handleChange}
              placeholder="Enter NAFDAC number"
            />
          </label>

          <button type="submit" className="btn">
            ✏️ Update Drug
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdateInventoryManually;
